let API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
  const { protocol, hostname } = window.location;
  API_URL = `${protocol}//${hostname}:3002`;
}

export default API_URL; 